angular.module('cfn').component('greening', {
  bindings: {
    farmId: '<',
    chartDataMainCrop: '<',
    chartDataCatchCrop: '<',
    chartDataInsideCrop: '<',
    greeningResults: '<',
    plannedFruits: '<',
    totalArea: '<',
    leavesArea: '<',
    cerealArea: '<',
    year: '<',
    isSecondFruit: '<',
    isCatchFruit: '<'
  },
  controller: GreeningController,
  controllerAs: 'vm',
  templateUrl: require('./greening.html')
});

GreeningController.$inject = ['$scope', 'i18nFilter'];
function GreeningController($scope, i18nFilter) {
  var vm = this;

  var mainCropMode = 'MAINCROP';
  var catchCropMode = 'CATCHCROP';

  vm.$onInit = function() {
    $scope.$watch('[vm.isSecondFruit,vm.isCatchFruit]', function() {
      if (!vm.isSecondFruit && !vm.isCatchFruit) {
        vm.tabSwitchMode = mainCropMode;
      }
    });
  };

  vm.tabSwitchMode = mainCropMode;
  vm.tabSwitchData = [
    {
      label: 'enums.SowingTypeEnum.MAIN_CROP',
      onSelect: function() {
        vm.tabSwitchMode = mainCropMode;
      },
      selected: true
    },
    {
      label: function() {
        return (
          i18nFilter('enums.SowingTypeEnum.CATCH_CROP', 'Zweitfrucht') +
          ' / ' +
          i18nFilter('enums.SowingTypeEnum.INSIDE_CROP', 'Zwischenfrucht')
        );
      },
      onSelect: function() {
        vm.tabSwitchMode = catchCropMode;
      }
    }
  ];
}
